import instance from '../instace';

export const createGumletAccount = async (name:string,token:string) => {
    try {
      const get: any = await instance.post('/api/admin/gumlet/account/create', {
      name,
      token,
      
      });
      return get.data;
    } catch (e) {
      return false;
    }
  };
  export const getGumletAccount = async () => {
    try {
      const get: any = await instance.get('/api/admin/gumlet/account/get');
      return get.data;
    } catch (e) {
      return false;
    }
  };
  export const showGumletAccount = async (id:string) => {
    try {
      const get: any = await instance.get('/api/admin/gumlet/account/get/'+id);
      return get.data;
    } catch (e) {
      return false;
    }
  };
  export const editGumletAccount = async (id:string,name:string,token:string) => {
    try {
      const get: any = await instance.put('/api/admin/gumlet/account/edit/'+id,{
        name,
        token,
      });
      return get.data;
    } catch (e) {
      return false;
    }
  };
  export const deleteGumletAccount = async (id:string) => {
    try {
      const get: any = await instance.delete('/api/admin/gumlet/account/delete/'+id);
      return get.data;
    } catch (e) {
      return false;
    }
  };

  export const getGumletCollections = async()=>{
    try{
        const get: any = await instance.get('/api/admin/gumlet/video/collection');
        return get.data;
     } catch (e) {
      return false;
    }
  }
  
  export const getGumletCollectionsPlaylist = async(id:string)=>{
    try{
        const get: any = await instance.get(`/api/admin/gumlet/video/collection/${id}/playlist`);
        return get.data;
     } catch (e) {
      return false;
    }
  }

  export const getGumletCollectionsPlaylistVideo = async(collectionId:string,id:string,page:number)=>{
    try{
        const get: any = await instance.get(`/api/admin/gumlet/video/collection/${collectionId}/playlist/${id}?page=${page}`);
        return get.data;
     } catch (e) {
      return false;
    }
  }
  export const getGumletToken = async()=>{
    try{
        const get: any = await instance.get(`/api/admin/gumlet/video/token`);
        return get.data;
     } catch (e) {
      return false;
    }
  }
  export const setDefaultGumletaAccount = async(id:string,status:any)=>{
    try{
        const get: any = await instance.put(`/api/admin/gumlet/account/default/${id}`,{
            status:status,
        });
        return get.data;
     } catch (e) {
      return false;
    }
  }
  export const importGumletPlaylistVideos = async(data:any,mod:any)=>{
    try{
        const get: any = await instance.post(`/api/admin/gumlet/video/import/playlist/videos`,{
            data:data,
            mod:mod
        });
        return get.data;
     } catch (e) {
      return false;
    }
  }
  export const importGumletPlaylistDir = async(collection:any,playlist:any,mod:any)=>{
    try{
        const get: any = await instance.post(`/api/admin/gumlet/video/import/playlist/dir`,{
          collection:collection,
          playlist:playlist,
            mod:mod
        });
        return get.data;
     } catch (e) {
      return false;
    }
  }